import { useState } from "react";
import { dayRank, monthRank, weekRank } from "@/mocks/community";
import SectionHeading from "./SectionHeading";

const tabs = [
  { key: "day", label: "日榜", data: dayRank },
  { key: "week", label: "周榜", data: weekRank },
  { key: "month", label: "月榜", data: monthRank },
];

export default function Rankings() {
  const [tab, setTab] = useState("day");
  const active = tabs.find((item) => item.key === tab) ?? tabs[0];

  return (
    <section id="rankings" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="04"
          title="热度榜单 · 大家都在看"
          subtitle="按播放与收藏热度实时排序，跟着榜单挑片不踩雷"
          actionLabel="榜单规则"
          actionHref="#rankings"
        />

        <div className="mb-5 inline-flex items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1">
          {tabs.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                tab === item.key
                  ? "bg-primary-500 font-medium text-background-50"
                  : "text-foreground-700 hover:text-primary-700"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="grid gap-x-8 gap-y-1 rounded-xl border border-background-200 bg-background-50 p-3 md:grid-cols-2 md:p-5">
          {active.data.map((item) => (
            <a
              key={item.rank}
              href="#rankings"
              className="group flex items-center gap-3 rounded-lg px-3 py-3 transition-colors hover:bg-background-100 md:gap-4"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-lg ${
                  item.rank <= 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-200 text-foreground-700"
                }`}
              >
                {item.rank}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground-950 group-hover:text-primary-700">
                  {item.title}
                </span>
                <span className="block text-xs text-foreground-500">{item.category}</span>
              </span>
              <span className="hidden w-24 sm:block">
                <span className="block h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <span
                    className="block h-full rounded-full bg-accent-500"
                    style={{ width: `${item.heat}%` }}
                  ></span>
                </span>
              </span>
              <span className="w-10 shrink-0 text-right font-heading text-sm text-accent-700">
                {item.score}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}